import { format } from "date-fns";
import { EvaluationEmailRecipient } from "./evaluation_email_recipient";

export class EvaluationEmailRecipients extends Array<EvaluationEmailRecipient> {
  constructor(recipients?: EvaluationEmailRecipient[]) {
    super();
    if (recipients instanceof Array) {
      recipients.forEach((recipient) => this.push(recipient));
    }
  }

  get local_last_updated_at(): Date | undefined {
    return this.length === 0
      ? undefined
      : this.map((recipient) =>
          recipient.created_at ? new Date(recipient.created_at) : undefined,
        ).sort((a, b) => (b?.getTime() ?? 0) - (a?.getTime() ?? 0))[0];
  }

  get local_last_updated_at_datetime_string(): string | undefined {
    if (!this.local_last_updated_at) return undefined;
    return format(this.local_last_updated_at, "MMM d, hh:mm aaa");
  }
}
